import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ArrowRight, CheckCircle2 } from "lucide-react"

export function HeroSectionModern() {
  return (
    <section className="relative min-h-[90vh] flex items-center bg-gradient-to-br from-background via-background to-primary/5">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 text-sm font-medium text-primary">
              <CheckCircle2 className="h-4 w-4" />
              Michigan's Infrastructure Experts
            </div>
            
            <div className="space-y-4">
              <h1 className="text-5xl font-bold leading-tight tracking-tight lg:text-6xl xl:text-7xl">
                Infrastructure
                <br />
                <span className="bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
                  Built Right
                </span>
              </h1>
              
              <p className="text-xl text-muted-foreground max-w-xl">
                Professional Horizontal Directional Drilling, fiber optic installation, and network infrastructure solutions delivered with precision and expertise.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="text-lg px-8">
                <Link href="/contact">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-lg px-8">
                <Link href="/about">
                  Learn More
                </Link>
              </Button>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t">
              <div>
                <div className="text-3xl font-bold text-primary">15+</div>
                <div className="text-sm text-muted-foreground">Years Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">500+</div>
                <div className="text-sm text-muted-foreground">Projects Done</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">100%</div>
                <div className="text-sm text-muted-foreground">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Right Visual */}
          <div className="relative lg:h-[600px]">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-primary/5 rounded-3xl" />
            <div className="absolute inset-4 bg-background/50 backdrop-blur-sm rounded-2xl border-2 border-primary/20 flex items-center justify-center">
              <div className="text-center space-y-4 p-8">
                <div className="text-6xl font-bold text-primary/30">HDD</div>
                <div className="text-2xl font-semibold text-foreground">Fiber Optics</div>
                <div className="text-lg text-muted-foreground">Network Infrastructure</div>
                <div className="grid grid-cols-2 gap-4 pt-6">
                  <div className="rounded-lg bg-primary/10 p-4 text-center">
                    <div className="text-2xl font-bold text-primary">24/7</div>
                    <div className="text-xs text-muted-foreground">Support</div>
                  </div>
                  <div className="rounded-lg bg-primary/10 p-4 text-center">
                    <div className="text-2xl font-bold text-primary">Fast</div>
                    <div className="text-xs text-muted-foreground">Delivery</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
